<template>
  <div class="user">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ title }}
        </h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-horizontal">
              <div
                v-if="isEdit"
                class="form-group text-center margin-50"
              >
                <div class="change-avatar">
                  <p
                    class="text-center"
                    style="margin-bottom: 10px;"
                  >
                    <img
                      :src="imgDataUrl || '/images/avatar/avatar.png'"
                      alt="User Avatar"
                      height="200"
                      width="200"
                    >
                  </p>
                  <a
                    class="btn btn-primary"
                    @click="toggleShow"
                  >{{ $t('label.uploadYourAvatar') }}</a>
                  <my-upload
                    v-model="show"
                    :headers="headers"
                    :height="200"
                    :params="params"
                    :url="`${apiUrl}/api/v1/user/change-avatar`"
                    :width="200"
                    field="avatar"
                    img-format="png"
                    lang-type="en"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">{{ $t('label.id_card') }}</label>
                <div class="col-sm-9">
                  <input
                    v-model="user.id_card"
                    :placeholder="$t('placeholder.id_card')"
                    autofocus
                    class="form-control"
                    type="text"
                  >
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">{{ $t('label.loan_officer_access_id') }}</label>
                <div class="col-sm-9">
                  <input
                    v-model="user.loan_officer_access_id"
                    :placeholder="$t('placeholder.loan_officer_access_id')"
                    autofocus
                    class="form-control"
                    type="text"
                  >
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">{{ $t('string.collection_officer') }}</label>
                <div class="col-sm-9">
                  <input
                    v-model="user.loandisk_collection_officer"
                    :placeholder="$t('string.enter_collection_officer_value_map_to_loandisk_system')"
                    autofocus
                    class="form-control"
                    type="text"
                  >
                </div>
              </div>
              <div
                class="form-group"
                :class="{'has-error' : validations.name }"
              >
                <label class="required col-sm-3 control-label">{{ $t('label.name') }}</label>
                <div class="col-sm-9">
                  <input
                    v-model="user.name"
                    :placeholder="$t('label.name')"
                    autofocus
                    class="form-control"
                    type="text"
                  >
                  <span
                    v-if="validations.name"
                    class="label-error"
                  >
                    {{ validations['name'][0] }}
                  </span>
                </div>
              </div>
              <div
                class="form-group"
                :class="{'has-error' : validations.email}"
              >
                <label class="required col-sm-3 control-label">{{ $t('label.email') }}</label>
                <div class="col-sm-9">
                  <input
                    v-model="user.email"
                    :placeholder="$t('label.email')"
                    autofocus
                    class="form-control"
                    type="email"
                  >
                  <span
                    v-if="validations.email"
                    class="label-error"
                  >
                    {{ validations['email'][0] }}
                  </span>
                </div>
              </div>
              <template v-if="!isEdit">
                <div
                  class="form-group"
                  :class="{'has-error' : validations.password}"
                >
                  <label class="required col-sm-3 control-label">{{ $t('label.password') }}</label>
                  <div class="col-sm-9">
                    <input
                      v-model="user.password"
                      :placeholder="$t('label.password')"
                      autofocus
                      class="form-control"
                      type="password"
                    >
                    <span
                      v-if="validations.password"
                      class="label-error"
                    >
                      {{ validations['password'][0] }}
                    </span>
                  </div>
                </div>
                <div
                  class="form-group"
                  :class="{'has-error' : validations.password_confirmation}"
                >
                  <label class="required col-sm-3 control-label">{{ $t('label.passwordConfirmation') }}</label>
                  <div class="col-sm-9">
                    <input
                      v-model="user.password_confirmation"
                      :placeholder="$t('label.passwordConfirmation')"
                      autofocus
                      class="form-control"
                      type="password"
                    >
                    <span
                      v-if="validations.password_confirmation"
                      class="label-error"
                    >
                      {{ validations['password_confirmation'][0] }}
                    </span>
                  </div>
                </div>
              </template>
              <div
                class="form-group"
                :class="{'has-error': validations.gender_id}"
              >
                <label class="required col-sm-3 control-label">{{ $t('label.gender') }}</label>
                <div class="col-sm-9">
                  <select
                    v-model="user.gender_id"
                    class="form-control"
                  >
                    <option
                      disabled
                      selected
                      :value="null"
                    >
                      {{ $t('string.selectGender') }}
                    </option>
                    <option value="1">
                      {{ $t('label.male') }}
                    </option>
                    <option value="2">
                      {{ $t('label.female') }}
                    </option>
                  </select>
                  <span
                    v-if="validations.gender_id"
                    class="label-error"
                  >
                    {{ validations['gender_id'][0] }}
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label class="required col-sm-3 control-label">{{ $t('label.active') }}</label>
                <div class="col-sm-9">
                  <label>
                    <input
                      v-model="user.active"
                      :value="true"
                      type="checkbox"
                    > {{ $t('label.active?') }}
                  </label>
                </div>
              </div>
              <div
                class="form-group"
                :class="{'has-error': validations.roles}"
              >
                <label class="required col-sm-3 control-label">{{ $t('label.roles') }}</label>
                <div class="col-sm-9">
                  <div class="row">
                    <div class="col-md-12">
                      <div :class="{'red-border pl-3': validations.roles}">
                        <div class="row">
                          <template v-if="rolesOption.length > 0">
                            <div
                              v-for="(role, key) in rolesOption"
                              :key="key"
                              class="col-md-12"
                            >
                              <label
                                :key="key"
                                style="color: #333333"
                              >
                                <input
                                  v-model="user.roles"
                                  :value="role"
                                  type="checkbox"
                                > {{ role['display_name_' + $i18n.locale] || role.name }}
                              </label>
                            </div>
                          </template>
                          <div class="col-md-12">
                            <span
                              v-if="validations.roles"
                              class="label-error"
                            >
                              {{ validations['roles'][0] }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                :class="{'has-error': validations.permissions}"
              >
                <label class="col-sm-3 control-label">{{ $t('label.additionalPermissions') }}</label>
                <div class="col-sm-9">
                  <div
                    :class="{'red-border': validations.permissions}"
                    class="permission-tree-wrapper"
                  >
                    <permission-tree
                      v-model="user.permissions"
                      :disable-all="disableAll"
                      :disabled-permissions="disabledPermissions"
                      :selected="selected"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-9 col-sm-offset-3">
                  <button
                    class="btn btn-primary btn-sm margin-r-5"
                    @click="onSubmit"
                  >
                    <i class="fa fa-check-circle" /> {{ $t('button.save') }}
                  </button>
                  <a
                    class="btn btn-default btn-sm"
                    @click="$router.back()"
                  >
                    <i class="fa fa-arrow-circle-left" /> {{ $t('button.back') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionTree from '@/components/PermissionTree'
import myUpload from 'vue-image-crop-upload'

export default {
  name: 'UserForm',
  components: {
    PermissionTree,
    myUpload
  },
  props: {
    title: {
      type: String,
      required: true
    },
    validations: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rolesOption: [],
      selected: null,
      apiUrl: process.env.VUE_APP_API,
      show: false,
      params: {
        uuid: this.$route.params.uuid,
        name: 'avatar'
      },
      headers: null,
      imgDataUrl: '',
      user: {
        email: null,
        password: null,
        password_confirmation: null,
        name: null,
        gender_id: null,
        active: true,
        roles: [],
        permissions: [],
        id_card: null,
        loan_officer_access_id: null,
        loandisk_collection_officer: null
      }
    }
  },
  computed: {
    isEdit () {
      return this.$route.name === 'edit-user'
    },
    disabledPermissions () {
      if (this.user && this.user.roles && Array.isArray(this.user.roles) && this.user.roles.length > 0) {
        const permissions = this.user.roles.map(role => role.permissions)
        if (Array.isArray(permissions) && permissions.length > 0) {
          const _permissions = permissions.reduce((p1, p2) => {
            if (Array.isArray(p1) && p1.length > 0 && Array.isArray(p2) && p2.length > 0) {
              return p1.concat(p2)
            }
          })
          if (Array.isArray(_permissions) && _permissions.length > 0) {
            return _permissions.map(permission => permission.id)
          }
        }
      }
      return []
    },
    disableAll () {
      return this.user.roles.some(role => role === process.env.VUE_APP_ROLE_ADMIN)
    }
  },
  watch: {
    user () {
      this.selected = this.user.permissions
      this.imgDataUrl = this.user.avatar ? this.apiUrl + '/' + this.user.avatar : this.user.avatar
    }
  },
  methods: {
    onSubmit () {
      this.$emit('submit', this.user)
    },
    async fetchRoles () {
      await this.$axios.post(process.env.VUE_APP_API + '/api/v1/role/get-roles')
        .then((response) => {
          this.rolesOption = response.data.data
          this.user.roles = this.rolesOption.filter(role => this.user.roles.map(r => r.id).includes(role.id))
        }).catch(error => {
          this.onResponseError(error)
        })
    },
    toggleShow () {
      this.show = !this.show
    },
    cropSuccess (imgDataUrl, field) {
    },
    cropUploadSuccess (jsonData) {
      this.imgDataUrl = this.apiUrl + '/' + jsonData.data.avatar
    },
    cropUploadFail (status, field) {
    },
    async fetchUserByUuid () {
      if (this.$route && this.$route.params && !this.$route.params.uuid) {
        return 0
      }

      await this.$axios.post(process.env.VUE_APP_API + '/api/v1/user/get-user-by-uuid', {
        uuid: this.$route.params.uuid
      }).then(({ data }) => {
        if (data.data) {
          this.user = data.data
        }
      }).catch(error => {
        this.onResponseError(error)
      })
    }
  },
  async mounted () {
    this.headers = {
      Authorization: 'Bearer ' + localStorage.getItem(this.$token),
      Accept: 'application/json'
    }
    await this.fetchUserByUuid()
    await this.fetchRoles()
  }
}
</script>

<style scoped>
.red-border {
  border-radius: 8px;
  border: 1px solid red;
}

.margin-50 {
  margin-bottom: 50px;
}

.permission-tree-wrapper {
  padding-bottom: 20px;
  overflow: auto;
}

.pl-3 {
  padding-left: 15px;
}
</style>
